import React from "react";
import ControlFeedback from "./ControlFeedback";
import RadioButtonListItem from "./RadioButtonListItem";
import { RadioButtonListControlProps } from "./Types";

const RadioButtonListControl: React.FC<RadioButtonListControlProps> = ({ name, value, disabled, width, validationResults, onChange, onBlur, layout, options }) => {

    let isValid = validationResults && validationResults.length > 0 ? false : true;

    if (width === undefined)
        width = '100%';

    if (!options)
        return <></>;

    var radios = options.map((option, index:number) => {
        return <RadioButtonListItem name={name} value={value} disabled={disabled} onChange={onChange} onBlur={onBlur} validationResults={validationResults} layout={layout} option={option}  />
    })

    return (
        <div style={{ width: width }}>
            {radios}
            <ControlFeedback isValid={isValid} validationResults={validationResults}></ControlFeedback>
        </div>
    );
}
export default RadioButtonListControl;